import {api} from '.';
import authStorage from './authStorage';
import {logo} from '../assets/images/images';

async function fetchDataFromProfile(apiEndpoint, defaultValue) {
  try {
    const authDetails = authStorage.getAuthDetails();
    if (!authDetails?.user) {
      return defaultValue;
    }
    const response = await api.get('/users/me/profile');
    const {company} = response.data;
    return company?.[apiEndpoint] || defaultValue;
  } catch (error) {
    return defaultValue;
  }
}

async function fetchCompanyPrimaryColor() {
  return await fetchDataFromProfile('color_code', '#3F7CDB');
}

async function fetchCompanyLogo() {
  return await fetchDataFromProfile('logo', logo);
}

export {fetchCompanyPrimaryColor, fetchCompanyLogo};
